export function toggleGuide(hook, target, className) {
  const $hook = $(hook);
  const $guideContainer = $(target);

  $hook.click(() => {
    $($guideContainer).toggleClass(className);
  });
}
